import { Wrapper, TinyText } from './styles';
import Link from '../../shared/Link';

const Footer = () => {
  return (
    <Wrapper>
      <TinyText>
        Built with{' '}
        <Link href="https://reactjs.org" target="_blank" rel="noreferrer">
          React
        </Link>{' '}
        &amp;{' '}
        <Link
          href="https://www.styled-components.com"
          target="_blank"
          rel="noreferrer"
        >
          styled-components
        </Link>
      </TinyText>
      <TinyText marginTop>
        Built &amp; designed by{' '}
        <Link
          href="https://github.com/amand33p"
          target="_blank"
          rel="noreferrer"
        >
          Amandeep Singh
        </Link>
      </TinyText>
    </Wrapper>
  );
};

export default Footer;
